import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filtroProximasSalidas'
})
export class FiltroProximasSalidasPipe implements PipeTransform {

  transform(snapshotArr: any, searchValue: string) {
    if (!snapshotArr) {
      return [];
    }
    if (!searchValue) {
      return snapshotArr;
    }
    if (snapshotArr && searchValue) {
      return snapshotArr.filter(snapshot => {
        return snapshot.NumeroPallet.toLowerCase().includes(searchValue.toLowerCase());
      });
    }
  }

}
